import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProductsPage from "./pages/ProductsPage";
import QualityPage from "./pages/QualityPage";
import ContactPage from "./pages/ContactPage";
import GlobalPresence from "./pages/GlobalPresence";
import Infusions from "./components/Infusions";
import Injections from "./components/Injections";
import Oncology from "./components/Oncology";
import RND from "./components/Rnd";
import ScrollToTop from "./components/ui/ScrollToTop";
import PageLoader from "./components/PageLoader";

const RouteLoader = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const id = setTimeout(() => setLoading(false), 200);
    return () => clearTimeout(id);
  }, [location.pathname]);

  return loading ? <PageLoader /> : null;
};

const AppLoader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const id = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(id);
  }, []);

  if (!loading) return null;
  return <PageLoader />;
};

function App() {
  return (
    <div className="App">
      <AppLoader />
      <BrowserRouter>
        <ScrollToTop />
        <RouteLoader />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<ProductsPage />} />
            {/* <Route path="/products/:category" element={<ProductsPage />} /> */}
            <Route path="/quality" element={<QualityPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/rd" element={<RND />} />
            <Route path="/global" element={<GlobalPresence />} />
            {/* <Route path="/privacy" element={<AboutPage />} />
            <Route path="/terms" element={<AboutPage />} /> */}
            <Route path="/products/infusions" element={<Infusions />} />
            <Route path="/products/injections" element={<Injections />} />
            <Route path="/products/oncology" element={<Oncology />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;